import Users from './Users.container';

export default Users;
